import React from 'react';
import ProductContext from './ProductContext.jsx';
import Drawer from './Drawer.jsx';
import SVG from './SVG.jsx';
import {formatMoney} from '@shopify/theme-currency';

export default class AfterPay extends React.PureComponent {
  constructor(props) {
    super();
    this.state = {open: false}

    this._open = this._open.bind(this);
    this._close = this._close.bind(this);
  }

  _open(e) {
    e.preventDefault();
    this.setState({open: true});
  }

  _close() {
    this.setState({open: false});
  }

  render() {
    if (!this.props.productTags.includes('no-afterpay') && this.props.productPrice >= 12500) {
      return <div className="afterpay">
        <span>or 4<span className="interestfree"> interest-free</span> payments of {formatMoney(this.props.productPrice / 4)} by </span>
        <SVG icon="afterpay" />
        <a href="#" aria-label="Info" onClick={this._open}>
          <SVG icon="info" />
        </a>
        <Drawer open={this.state.open} content={this.context.productSettings.afterPayDetails} contentClass='afterpay-drawer' _close={this._close} mountOnEnter={false} unmountOnExit={true} />
      </div>
    }

    return (null);
  }
}

AfterPay.contextType = ProductContext;